import { render, staticRenderFns } from "./AuthenticationLoginV2.vue?vue&type=template&id=3b091eb0&scoped=true"
import script from "./AuthenticationLoginV2.vue?vue&type=script&lang=js"
export * from "./AuthenticationLoginV2.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./AuthenticationLoginV2.vue?vue&type=style&index=1&id=3b091eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b091eb0",
  null
  
)

export default component.exports